import Button from "@app/components/Button/Button";
import clsx from "clsx";
import { useState } from "react";

type AlphabetFilterProps = {
  onSelect?: (letter: string | null) => void;
  className?: string;
};

export default function AlphabetFilter({
  onSelect,
  className,
}: AlphabetFilterProps) {
  const [selected, setSelected] = useState<string | null>("All");

  const letters = [
    "All",
    ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  ];

  const handleClick = (letter: string | null) => {
    setSelected(letter);
    onSelect?.(letter);
  };

  return (
    <div
      data-testid="alphabet-filter"
      className={clsx(
        "flex w-full flex-wrap items-center px-3 py-4",
        className,
      )}
    >
      {/* Alphabet Buttons */}
      {letters.map((letter) => {
        const isSelected = selected === letter;
        return (
          <Button
            key={letter}
            variant="ghost"
            size="medium"
            onClick={() => {
              handleClick(letter);
            }}
            className={clsx("h-8", isSelected && "bg-button-ghost-hover!")}
          >
            {letter}
          </Button>
        );
      })}
    </div>
  );
}
